import axios from "axios"

const { 
    REACT_APP_URI_INDUSTRY: URI_INDUSTRY,
} = process.env

export const fetchIndustries = async ({
    page = 1,
    limit = 20,
    search = "",
    sort = { field: "name", order: "ASC" },
    rol = "",
    dataID = ""
}) => {
    const offset = (page - 1) * limit
    
    const params = new URLSearchParams({
        offset,
        limit,
        search,
        sortField: sort.field,
        sortOrder: sort.order,
        rol,
        dataID,
    })
    
    const route = `${URI_INDUSTRY}?${params.toString()}`

    const { data } = await axios.get(route)

    return data
}

export const createIndustry = async (industryName) => {
    const { data } = await axios.post(URI_INDUSTRY, { industryName })
    
    return data
}
